import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import MobileNav from './MobileNav';
import './Layout.css';

const Layout = () => {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="portal-layout">
      <Sidebar collapsed={collapsed} onToggle={setCollapsed} />
      <main 
        className="portal-main"
      >
        <Outlet />
      </main>
      <MobileNav />
    </div>
  );
};

export default Layout;
